import {
  LOGIN,
  LOGOUT,
  REGISTER,
  SET_EMAIL,
  SET_TOKEN,
  SET_INITIALIZED,
  SET_LOADING,
  SET_ERROR,
} from "./actions";
import { normalizeAuthUser } from "utils/adminAccess";

export const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  isLoading: false,
  user: null,
  accessToken: null,
  email: null,
  error: null,
};

const TEMP_AUTH_KEY = "temp_auth_state";

export const saveStateToStorage = (state) => {
  try {
    if (!state) {
      // If state is null, just remove the item from localStorage
      localStorage.removeItem(TEMP_AUTH_KEY);
      return;
    }

    const minimalUser = normalizeAuthUser(state.user);

    localStorage.setItem(
      TEMP_AUTH_KEY,
      JSON.stringify({
        isLoggedIn: state.isLoggedIn,
        user: minimalUser,
        accessToken: state.accessToken,
        email: state.email,
      }),
    );
  } catch (error) {
    console.error("Error saving state:", error);
  }
};

export const getStoredState = () => {
  try {
    const storedState = localStorage.getItem(TEMP_AUTH_KEY);
    // Clear immediately after retrieving
    localStorage.removeItem(TEMP_AUTH_KEY);
    return storedState ? JSON.parse(storedState) : null;
  } catch (error) {
    console.error("Error getting stored state:", error);
    return null;
  }
};

const auth = (state = initialState, action) => {
  try {
    switch (action.type) {
      case REGISTER: {
        const { user } = action.payload;
        return {
          ...state,
          user: normalizeAuthUser(user),
        };
      }
      case LOGIN: {
        const { user, accessToken } = action.payload;
        return {
          ...state,
          isLoggedIn: true,
          isInitialized: true,
          user: normalizeAuthUser(user),
          accessToken,
          error: null,
        };
      }
      case LOGOUT: {
        return {
          ...initialState,
          isInitialized: true,
        };
      }
      case SET_TOKEN: {
        const { accessToken } = action.payload;
        return {
          ...state,
          accessToken,
          isLoggedIn: true,
        };
      }
      case SET_INITIALIZED: {
        return {
          ...state,
          isInitialized: true,
        };
      }
      case SET_EMAIL: {
        const { email } = action.payload;
        return {
          ...state,
          email,
        };
      }
      case SET_LOADING: {
        return {
          ...state,
          isLoading: action.payload,
        };
      }
      case SET_ERROR: {
        return {
          ...state,
          error: action.payload,
          isLoading: false,
        };
      }
      default: {
        return state;
      }
    }
  } catch (error) {
    console.error(`Error in auth reducer from ${action.type}:`, error);
    return {
      ...state,
      error: error.message,
      isLoading: false,
    };
  }
};

// Selectors
export const selectIsAuthenticated = (state) =>
  state.auth.isLoggedIn && !!state.auth.accessToken;
export const selectUser = (state) => state.auth.user;
export const selectIsInitialized = (state) => state.auth.isInitialized;
export const selectError = (state) => state.auth.error;
export const selectIsLoading = (state) => state.auth.isLoading;
export const selectAccessToken = (state) => state.auth.accessToken;
export const selectEmail = (state) => state.auth.email;

export default auth;
